import { baseService } from "./base";

export const versionsService = {
  loadAll(params = {}, options = {}) {
    return baseService.get("/api/applications/params", params, options);
  },
};

export default versionsService;
